import * as yup from 'yup'

const createWorkOrder = yup.object({
  permissionToEnter: yup.boolean(),
  petsDescription: yup.boolean(),
  maintenanceCategoryId: yup.string().required(),
  maintenancePriorityId: yup.string().required(),
  maintenanceLocationId: yup.string().required(),
  maintenanceProblemId: yup.string().required(),
  problemDescription: yup.string().required(),
  additionalInfo: yup.string().required(),
})

export default createWorkOrder
